module.exports = __webpack_public_path__ + "img/fd8aaef1c17e35b144cd4c84423707b6.png";